import React, { Fragment, useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  List,
  ListItemText,
} from "@material-ui/core";

// Contexts
import AlertContext from "../../../../../../context/alert/AlertContext";
import OrderContext from "../../../../../../context/orders/v1/OrdersContext";
import MernCountryContext from "../../../../../../context/mern_Countries/CountryContext";

const useStyles = makeStyles((theme) => ({
  form: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    width: "48%",
  },
  textFieldLeft: {
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    width: "48%",
  },
  dialogActions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  errorMessages: {
    fontSize: "0.7rem",
    backgroundColor: "#FFE4E1",
    border: "2px solid red",
    padding: "0.5rem 0 0.5rem 1rem",
    marginBottom: "0.5rem",
  },
  button: {
    textTransform: "none",
  },
}));

const InfoShipping = ({ handleClose }) => {
  const classes = useStyles();

  const { setAlert } = useContext(AlertContext);
  const {
    modalFunction,
    modalValues,
    modalErrors,
    modalStates,
    setValues,
    setErrors,
    setModalStates,
    order,
    order_error,
    updateShippingAdd,
  } = useContext(OrderContext);
  const { mern_countries } = useContext(MernCountryContext);

  const [provinces, setProvinces] = useState([]);

  const setprovinceslist = (country_name) => {
    for (let c in mern_countries) {
      const country = mern_countries[c];

      if (country.country === country_name || country.iso2 === country_name) {
        // Set Provinces List
        setProvinces(country.provinces);

        return [country.iso2, country.provinces];
      }
    }
  };

  const handleChange = (e) => {
    let id;
    const value = e.target.value;

    if (e.target.id) {
      id = e.target.id;
    } else {
      id = e.target.name;
    }

    let new_values = Object.assign({}, modalValues);
    let new_errors = Object.assign({}, modalErrors);

    new_values[id] = value;

    if (id === "country") {
      const [country_code, provinces] = setprovinceslist(value);

      // Set Country Code & Set Province, Province Code
      new_values["country_code"] = country_code;

      new_values["province_code"] =
        provinces.length === 0 ? null : provinces[0].code;

      new_values["province"] =
        provinces.length === 0 ? null : provinces[0].name;
    } else if (id === "province") {
      for (let p in provinces) {
        if (provinces[p].name === value) {
          // Set Province Code
          new_values["province_code"] = provinces[p].code;
        }
      }
    }

    // Regex
    const validPostalCodeRegex = /^[a-zA-Z0-9-]{3,10}$/;

    switch (id) {
      case "phone":
        if (value.length < 1) {
          new_errors.phone = "Phone cannot be empty!";
        } else {
          new_errors.phone = "";
        }
        break;
      case "last_name":
        if (value.length < 1) {
          new_errors.last_name = "Last Name cannot be empty!";
        } else {
          new_errors.last_name = "";
        }
        break;
      case "address1":
        if (value.length < 1) {
          new_errors.address1 = "Address cannot be empty!";
        } else {
          new_errors.address1 = "";
        }
        break;
      case "city":
        if (value.length < 1) {
          new_errors.city = "City cannot be empty!";
        } else {
          new_errors.city = "";
        }
        break;
      case "zip":
        if (value.length < 1) {
          new_errors.zip = "Zip cannot be empty!";
        } else if (!validPostalCodeRegex.test(value)) {
          new_errors.zip = "Zip is invalid!";
        } else {
          new_errors.zip = "";
        }
        break;
      default:
        break;
    }

    setValues(new_values);
    setErrors(new_errors);
  };

  const onSubmit = (e) => {
    e.preventDefault();

    let valid = true;

    // Validation - errors
    Object.values(modalErrors).map((each) => {
      if (each && each !== "*") {
        valid = false;
      }

      return valid;
    });

    if (valid) {
      // Check If Any Changes Made
      let new_changed = false;

      Object.entries(modalValues).map(([key, val]) => {
        if (order.shipping_address && order.shipping_address[key] !== val) {
          new_changed = true;
        } else {
          new_changed = true;
        }

        return new_changed;
      });

      if (new_changed) {
        setModalStates({
          submitted: true,
          changed: new_changed,
        });
        updateShippingAdd(order.store_name, order.id, modalValues);
      } else {
        handleClose();
        setAlert("No changes has been made.", "info");
      }
    }
  };

  useEffect(() => {
    if (modalFunction === "shipping_info" && mern_countries) {
      if (order.shipping_address) {
        let values = {
          first_name: order.shipping_address.first_name,
          last_name: order.shipping_address.last_name,
          address1: order.shipping_address.address1,
          address2: order.shipping_address.address2,
          city: order.shipping_address.city,
          province: order.shipping_address.province,
          province_code: order.shipping_address.province_code,
          zip: order.shipping_address.zip,
          country: order.shipping_address.country,
          country_code: order.shipping_address.country_code,
          phone: order.shipping_address.phone,
        };

        if (order.shipping_address.country) {
          const [country_code, provinces] = setprovinceslist(
            order.shipping_address.country
          );

          values["country_code"] = country_code;
          // Commented because onLoad province_code always auto select the first one
          // values["province_code"] =
          //   provinces.length === 0 ? null : provinces[0].code;
        }

        setValues(values);

        setErrors({
          first_name: null,
          last_name: null,
          address1: null,
          address2: null,
          city: null,
          province: null,
          province_code: null,
          zip: null,
          country: null,
          country_code: null,
          phone: null,
        });
      }
    }
  }, [modalFunction, mern_countries]);

  return (
    modalFunction === "shipping_info" &&
    mern_countries && (
      <Fragment>
        <DialogTitle> Edit shipping address </DialogTitle>
        <DialogContent dividers>
          {" "}
          {modalErrors && modalErrors.zip === "*" && (
            <List dense={true} className={classes.errorMessages}>
              <ListItemText>
                <strong>
                  There are {order_error.errors.shipping_address.length}{" "}
                  error(s):
                </strong>{" "}
              </ListItemText>{" "}
              {order_error.errors.shipping_address.map((each, index) => {
                return (
                  <ListItemText key={index}>
                    & ensp; & bull; & ensp; {each}{" "}
                  </ListItemText>
                );
              })}{" "}
            </List>
          )}{" "}
          <form className={classes.form}>
            <TextField
              className={classes.textFieldLeft}
              label="First name"
              id="first_name"
              value={modalValues.first_name ? modalValues.first_name : ""}
              onChange={handleChange}
              error={modalErrors.first_name ? true : false}
              helperText={modalErrors.first_name ? modalErrors.first_name : ""}
            />
            <TextField
              className={classes.textField}
              label="Last name"
              id="last_name"
              value={modalValues.last_name ? modalValues.last_name : ""}
              onChange={handleChange}
              error={modalErrors.last_name ? true : false}
              helperText={modalErrors.last_name ? modalErrors.last_name : ""}
            />
            <TextField
              className={classes.textFieldLeft}
              label="Phone number"
              id="phone"
              value={modalValues.phone ? modalValues.phone : ""}
              onChange={handleChange}
              error={modalErrors.phone ? true : false}
              helperText={modalErrors.phone ? modalErrors.phone : ""}
            />
            <TextField
              className={classes.textField}
              label="Address"
              id="address1"
              value={modalValues.address1 ? modalValues.address1 : ""}
              onChange={handleChange}
              error={modalErrors.address1 ? true : false}
              helperText={modalErrors.address1 ? modalErrors.address1 : ""}
            />
            <TextField
              className={classes.textFieldLeft}
              label="Apartment, suite, etc. (optional)"
              id="address2"
              value={modalValues.address2 ? modalValues.address2 : ""}
              onChange={handleChange}
              error={modalErrors.address2 ? true : false}
              helperText={modalErrors.address2 ? modalErrors.address2 : ""}
            />
            <TextField
              className={classes.textField}
              label="City"
              id="city"
              value={modalValues.city ? modalValues.city : ""}
              onChange={handleChange}
              error={modalErrors.city ? true : false}
              helperText={modalErrors.city ? modalErrors.city : ""}
            />
            <TextField
              select
              SelectProps={{
                native: true,
              }}
              className={classes.textFieldLeft}
              label="Country/Region"
              id="country"
              name="country"
              value={modalValues.country}
              onChange={handleChange}
              error={modalErrors.country ? true : false}
              helperText={modalErrors.country ? modalErrors.country : ""}
            >
              {mern_countries.map((each) => {
                return (
                  <option key={each.iso2} value={each.country}>
                    {" "}
                    {each.country}{" "}
                  </option>
                );
              })}{" "}
            </TextField>
            {provinces.length > 0 && (
              <TextField
                select
                SelectProps={{
                  native: true,
                }}
                className={classes.textField}
                label="State"
                id="province"
                name="province"
                value={modalValues.province}
                onChange={handleChange}
                error={modalErrors.province ? true : false}
                helperText={modalErrors.province ? modalErrors.province : ""}
              >
                {provinces.map((each) => {
                  return (
                    <option key={each.code} value={each.name}>
                      {" "}
                      {each.name}{" "}
                    </option>
                  );
                })}{" "}
              </TextField>
            )}
            <TextField
              className={classes.textField}
              label="ZIP/Postal code"
              id="zip"
              value={modalValues.zip ? modalValues.zip : ""}
              onChange={handleChange}
              error={modalErrors.zip ? true : false}
              helperText={modalErrors.zip ? modalErrors.zip : ""}
            />{" "}
          </form>{" "}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={onSubmit}
            disabled={modalStates.submitted}
          >
            Save{" "}
          </Button>{" "}
          <Button
            variant="contained"
            className={classes.button}
            onClick={handleClose}
            disabled={modalStates.submitted}
          >
            Cancel{" "}
          </Button>{" "}
        </DialogActions>{" "}
      </Fragment>
    )
  );
};

export default InfoShipping;
